<div class="ui-g-12">
  <div class="ui-g-6 text-center">
    <label>{{ 'campaign.touchpoint' | translate }}</label>
  </div>
  <div class="ui-g-6 text-center">
    <label>{{ 'campaign.campaignPriority' | translate }}</label>
  </div>
  <div class="ui-g-12">
    <!-- <div class="flex">
      
      
    </div>   -->
    <div class="flex">
        <div class="container channels-list" dragula="CHANNELS" [(dragulaModel)]="channelsList">
          <div class="channel" *ngFor="let channel of channelsList">{{ channel.label }}</div>
        </div>

        <div class="container priorities-list" dragula="CHANNELS" [(dragulaModel)]="priorityList">
          <div class="channel" *ngFor="let priority of priorityList">{{ priority.label }}
            <input type = "hidden" [name]="priority.label" [value]="priority.value" />
          </div>    
        </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-drag-and-drop/campaign-drag-and-drop.component.html